/* istanbul ignore file */
import styled from 'styled-components'
import { Select } from 'commons/js/components/Select'

import {
    themeColor,
    themeFontWeight,
    themeFontSize,
    themeBorderRadius,
} from '@elparking/components'

import {
    padding,
    height,
    minHeight,
} from 'commons/js/theme/styles'

const StyledSelect = styled(Select)`
    font-size: ${themeFontSize('small')};
    font-weight: ${themeFontWeight('regular')};

    .Select__value-container {
        width: 100%;
    }

    .Select__value-container .Select__placeholder,
    .Select__value-container .Select__single-value,
    .Select__input-container {
        width: 100%;
        color: ${themeColor('gray')};
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .Select__value-container .Select__single-value {
        display: block;
        max-width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .Select-value-container-label {
        line-height: 1.2em;
        color: ${themeColor('gray')};
        font-weight: ${themeFontWeight('medium')};
    }

    .Select__control {
        border: 1px solid ${themeColor('lightGray40')};
        ${padding}
        ${height}
        ${minHeight}
        min-width: 100%;
        outline: none;
        margin: 0;
        position: inherit;
        border-radius: ${themeBorderRadius()};
        height: 100%;
        max-width: fit-content;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: center;
        box-shadow: none;
    }

    &.is-disabled .Select__arrow-zone {
        opacity: 1;
    }


    .Select__input > input {
        font-weight: ${themeFontWeight('book')};
        color: ${themeColor('gray')};
    }

    &.Select__placeholder {
        color: ${themeColor('gray60')};
        padding-top: 0px;
        top: 0px;
    }

    .Select__menu,
    .Select__menu-outer {
        background: ${themeColor('white')};
    }

    .Select__menu {
        margin: 0;
        border-radius: 0;
        z-index: 2;
        padding: 0;
    }

    .Select__menu-outer{
        overflow: hidden;
        background: red;
    }

    .Select__option {
        line-height: 1.5em;
        color: ${themeColor('gray')};
        font-size: ${themeFontSize('small')};
        font-weight: ${themeFontWeight('regular')};
    }

    .Select__option--is-focused {
        background-color: ${themeColor('accent40')};
        color: ${themeColor('darkMain')};
    }

    .Select__option--is-selected {
        background-color: ${themeColor('accent')};
        color: ${themeColor('darkMain')};
    }

    .Select__indicators {
        padding: 0 0.5em;
    }
`

export default StyledSelect
